import { Action, createReducer, on } from "@ngrx/store";
import { IPackageWarehouseState } from "./package-warehouse";
import { BENI_CONTO_DEPOSITO_SUCCESS, CHANGE_STATUS_VERIFICA_SUCCESS, CHIUDI_SCATOLA_SUCCESS, CHIUSURA_SCATOLE_BXL_SUCCESS, ESPORTA_FILE_MAIL_SUCCESS, ESPORTA_FILE_XLS_SUCCESS, EXISTS_SCATOLA_FLYER_SUCCESS, MOVIMENTAZIONE_CREATE_EVENT_SUCCESS, MOVIMENTAZIONE_LIST_SUCCESS, PACCHI_IN_GIACENZA_SUCCESS, RETRIVE_BOX_TO_CHECK_SUCCESS, SCATOLA_NON_DISPONIBILE_SUCCESS, STORICO_ANNUALE_CONTO_DEPOSITO_SUCCESS, STORICO_OGGETTO_CONTO_DEPOSITO_SUCCESS } from "./package-warehouse.actions";
import { IPacchiInGiacenzaResponse } from "../../interfaces/response-pacchi-giacenza";
import { IMovimentazioneListResponse } from "../../interfaces/movimentazione-list";
import { IMovimentazioneMailResponse } from "../../interfaces/movimentazione-mail";
import { IVerificaMagazzinoPacchi } from "../../interfaces/response-verifica-magazzino-pacchi";
import { IBeniContoDeposito } from "../../interfaces/beni-conto-deposito";
import { IResponseScatolaNonDisponibile } from "../../interfaces/scatola-non-disponibile";
import { IResponseChangeStatusVerifica } from "../../interfaces/change-status-verifica";
import { IResponseExistsScatolaFlyer } from "../../interfaces/exists-scatola-flyer";
import { IResponseChiudiScatola } from "../../interfaces/chiudi-scatola";
import { IResponseChiusuraScatoleBxl } from "../../interfaces/chiusura-scatole-bxl";
import { IResponseStoricoOggettoContoDeposito } from "../../interfaces/storico-oggetto-conto-deposito";
import { IPayloadMovimentazioneCreateEvent, IResponseMovimentazioneCreateEvent } from "../../interfaces/movimentazione-create-event";

/* INITIAL STATE */
const initialState: IPackageWarehouseState = {
  responsePacchiInGiacenza: null,
  responseMovimentazione: null,
  responseEsportaXls: null,
  responseEsportaMail: null,
  responseVerificaBox: null,
  responseBeniContoDeposito: null,
  responseScatolaNonDisponibile: null,
  responseChangeStatusVerifica: null,
  responseExistsScatolaFlyer: null,
  responseChiudiScatola: null,
  responseChiusuraScatoleBxl: null,
  responseStoricoContoDeposito: null,
  responseStoricoAnnualeContoDeposito: null,
  responseMovimentazioneCreateEvent: null,
};

const handlePacchiInGiacenza = (
  state: IPackageWarehouseState,
  { responsePacchiInGiacenza }: { responsePacchiInGiacenza: IPacchiInGiacenzaResponse | null }
): IPackageWarehouseState => {
  return {
    ...state,
    responsePacchiInGiacenza,
  };
};

const handleMovimentazioneList = (
  state: IPackageWarehouseState,
  { responseMovimentazione }: { responseMovimentazione: IMovimentazioneListResponse | null }
): IPackageWarehouseState => {
  return {
    ...state,
    responseMovimentazione,
  };
};

const handleEsportaXls = (
  state: IPackageWarehouseState,
  { responseEsportaXls }: { responseEsportaXls: any }
): IPackageWarehouseState => {
  return {
    ...state,
    responseEsportaXls,
  };
};

const handleEsportaFile = (
  state: IPackageWarehouseState,
  { responseEsportaMail }: { responseEsportaMail: IMovimentazioneMailResponse | null }
): IPackageWarehouseState => {
  return {
    ...state,
    responseEsportaMail,
  };
};

const handleRetriveBoxToCheck = (
  state: IPackageWarehouseState,
  { responseVerificaBox }: { responseVerificaBox: IVerificaMagazzinoPacchi | null }
): IPackageWarehouseState => {
  return {
    ...state,
    responseVerificaBox
  }
}

const handleBeniContoDeposito = (
  state: IPackageWarehouseState,
  { responseBeniContoDeposito }: { responseBeniContoDeposito: IBeniContoDeposito | null }
): IPackageWarehouseState => {
  return {
    ...state,
    responseBeniContoDeposito,
  };
};

const handleScatolaNonDisponibile = (
  state: IPackageWarehouseState,
  { responseScatolaNonDisponibile }: { responseScatolaNonDisponibile: IResponseScatolaNonDisponibile | null }
): IPackageWarehouseState => {
  return {
    ...state,
    responseScatolaNonDisponibile,
  };
};

const handleChangeStatusVerifica = (
  state: IPackageWarehouseState,
  { responseChangeStatusVerifica }: { responseChangeStatusVerifica: IResponseChangeStatusVerifica | null }
): IPackageWarehouseState => {
  return {
    ...state,
    responseChangeStatusVerifica,
  };
};

const handleExistsScatolaFlyer = (
  state: IPackageWarehouseState,
  { responseExistsScatolaFlyer }: { responseExistsScatolaFlyer: IResponseExistsScatolaFlyer | null }
): IPackageWarehouseState => {
  return {
    ...state,
    responseExistsScatolaFlyer,
  };
};

const handleChiudiScatola = (
  state: IPackageWarehouseState,
  { responseChiudiScatola }: { responseChiudiScatola: IResponseChiudiScatola | null }
): IPackageWarehouseState => {
  return {
    ...state,
    responseChiudiScatola,
  };
};

const handleChiusuraScatoleBxl = (
  state: IPackageWarehouseState,
  { responseChiusuraScatoleBxl }: { responseChiusuraScatoleBxl: IResponseChiusuraScatoleBxl | null }
): IPackageWarehouseState => {
  return {
    ...state,
    responseChiusuraScatoleBxl,
  };
};

const handleStoricoContoDeposito = (
  state: IPackageWarehouseState,
  { responseStoricoContoDeposito }: { responseStoricoContoDeposito: IResponseStoricoOggettoContoDeposito | null }
): IPackageWarehouseState => {
  return {
    ...state,
    responseStoricoContoDeposito,
  };
};

const handleStoricoAnnualeContoDeposito = (
  state: IPackageWarehouseState,
  { responseStoricoAnnualeContoDeposito }: { responseStoricoAnnualeContoDeposito: any }
): IPackageWarehouseState => {
  return {
    ...state,
    responseStoricoAnnualeContoDeposito,
  };
};

const handleMovimentazioneCreateEvent = (
  state: IPackageWarehouseState,
  { responseMovimentazioneCreateEvent }: { responseMovimentazioneCreateEvent: IResponseMovimentazioneCreateEvent | null }
): IPackageWarehouseState => {
  return {
    ...state,
    responseMovimentazioneCreateEvent,
  };
};

/* REDUCER */
export const reducer = createReducer(
  initialState,
  on(PACCHI_IN_GIACENZA_SUCCESS, handlePacchiInGiacenza),
  on(MOVIMENTAZIONE_LIST_SUCCESS, handleMovimentazioneList),
  on(ESPORTA_FILE_XLS_SUCCESS, handleEsportaXls),
  on(ESPORTA_FILE_MAIL_SUCCESS, handleEsportaFile),
  on(RETRIVE_BOX_TO_CHECK_SUCCESS, handleRetriveBoxToCheck),
  on(BENI_CONTO_DEPOSITO_SUCCESS, handleBeniContoDeposito),
  on(SCATOLA_NON_DISPONIBILE_SUCCESS, handleScatolaNonDisponibile),
  on(CHANGE_STATUS_VERIFICA_SUCCESS, handleChangeStatusVerifica),
  on(EXISTS_SCATOLA_FLYER_SUCCESS, handleExistsScatolaFlyer),
  on(CHIUDI_SCATOLA_SUCCESS, handleChiudiScatola),
  on(CHIUSURA_SCATOLE_BXL_SUCCESS, handleChiusuraScatoleBxl),
  on(STORICO_OGGETTO_CONTO_DEPOSITO_SUCCESS, handleStoricoContoDeposito),
  on(STORICO_ANNUALE_CONTO_DEPOSITO_SUCCESS, handleStoricoAnnualeContoDeposito),
  on(MOVIMENTAZIONE_CREATE_EVENT_SUCCESS, handleMovimentazioneCreateEvent),
);

export const packageWarehouseReducer = (
  state: IPackageWarehouseState | undefined,
  action: Action
): IPackageWarehouseState => reducer(state, action);
